var _defs, _path, _path2, _path3, _path4, _path5, _g, _path6, _ellipse, _path7, _ellipse2, _ellipse3, _path8, _path9, _path10, _ellipse4, _ellipse5, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _g2, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _g3, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRegistryHero(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "registry-hero_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 540 540"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "registry-hero_svg__linear-gradient",
    x1: -136.44,
    y1: 82.1,
    x2: -111.32,
    y2: 82.1,
    gradientTransform: "rotate(30 147.137 1093.555)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#52c7ea",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "registry-hero_svg__linear-gradient-2",
    x1: -1660.29,
    y1: 234.56,
    x2: -1633.11,
    y2: 234.56,
    gradientTransform: "matrix(-1 0 0 1 -1555.06 0)",
    xlinkHref: "#registry-hero_svg__linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "registry-hero_svg__linear-gradient-3",
    x1: -1766.74,
    y1: 172.22,
    x2: -1746.19,
    y2: 172.22,
    gradientTransform: "matrix(-1 0 0 1 -1555.06 0)",
    xlinkHref: "#registry-hero_svg__linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "registry-hero_svg__linear-gradient-4",
    x1: -1681.97,
    y1: 186.31,
    x2: -1581.36,
    y2: 186.31,
    gradientTransform: "matrix(-1 0 0 1 -1555.06 0)",
    xlinkHref: "#registry-hero_svg__linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "registry-hero_svg__linear-gradient-5",
    x1: 628.12,
    y1: 293.05,
    x2: 648.85,
    y2: 293.05,
    gradientTransform: "matrix(1 0 .09 -1 -605.55 542)",
    xlinkHref: "#registry-hero_svg__linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "registry-hero_svg__linear-gradient-6",
    x1: 232.25,
    y1: 347.77,
    x2: 646.14,
    y2: 347.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#52c7ea",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "registry-hero_svg__linear-gradient-7",
    x1: 226.98,
    y1: 273.91,
    x2: 432.67,
    y2: 367.2,
    xlinkHref: "#registry-hero_svg__linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "registry-hero_svg__clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "registry-hero_svg__cls-1",
    d: "M402.41 90.73l.09-28.38 24.7 14.26-.08 28.39-24.71-14.27z"
  })), /*#__PURE__*/React.createElement("style", null, ".registry-hero_svg__cls-1{fill:none}.registry-hero_svg__cls-2{fill:#152935}.registry-hero_svg__cls-4{fill:#52c7ea}.registry-hero_svg__cls-9{fill:#05131c}.registry-hero_svg__cls-10{fill:#05151c}.registry-hero_svg__cls-12{fill:#0a1a2b}.registry-hero_svg__cls-13{fill:#ec432d}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "registry-hero_svg__cls-2",
    d: "M448.92 240.75h-26.57l6.31-170.9h8.27l11.99 170.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "registry-hero_svg__cls-2",
    d: "M449 58.69c-4.92-8.52-12.87-13.14-17.76-10.32a6 6 0 00-1.55 1.29l-20.44 17c-4.89 2.82-4.87 12 .05 20.54s12.87 13.13 17.76 10.31a6 6 0 001.55-1.29l20.44-17c4.89-2.82 4.87-12.01-.05-20.53z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 418.16,
    cy: 82.1,
    rx: 10.22,
    ry: 17.81,
    transform: "rotate(-30 418.16 82.106)",
    style: {
      isolation: "isolate"
    },
    fill: "url(#registry-hero_svg__linear-gradient)",
    opacity: 0.3
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "registry-hero_svg__cls-4",
    d: "M434.62 96.6a21.3 21.3 0 01-15.43-6.18l-6.56-6.56a.41.41 0 01-.1-.34.36.36 0 01.21-.27l.42-.19 109.42-50.69a2.08 2.08 0 012.78.71 2.69 2.69 0 01-.89 3.47L453.17 90a31.52 31.52 0 01-18.55 6.6zm-21.08-12.9l6.18 6.19a20.55 20.55 0 0014.9 6 30.78 30.78 0 0018.1-6.5L524 36a1.93 1.93 0 00.7-2.48 1.32 1.32 0 00-1.82-.42z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "registry-hero_svg__cls-4",
    d: "M417.32 189.82a1.92 1.92 0 01-1.87-1.37l-22-67.89c-3.59-11.06 1.19-24.26 11.61-32.1l8.28-6.22a.39.39 0 01.39 0 .37.37 0 01.21.32v.6l5.93 104a2.59 2.59 0 01-2.13 2.68 2.09 2.09 0 01-.42-.02zM413.2 83.26l-7.71 5.8c-10.18 7.65-14.85 20.51-11.36 31.27l22 67.88a1.19 1.19 0 001.45.84 1.86 1.86 0 001.53-1.91z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "registry-hero_svg__cls-4",
    d: "M413.72 84.06a.45.45 0 01-.19 0l-.43-.26-88-51.48a2.43 2.43 0 01-.84-3.13 2.45 2.45 0 012.77-1.7l71 16.19c11.63 2.65 18.72 14.53 17.25 28.88l-1.18 11.16a.39.39 0 01-.21.3.33.33 0 01-.17.04zm-87.2-55.93a1.84 1.84 0 00-1.59 1.29 1.73 1.73 0 00.53 2.2l88 51.44 1.09-10.62c1.44-14-5.42-25.52-16.66-28.08l-71-16.19a1.22 1.22 0 00-.37-.04z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#registry-hero_svg__clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "registry-hero_svg__cls-2",
    d: "M414.85 69.48c-6.83-3.94-12.37-.78-12.4 7.07s5.49 17.38 12.32 21.32 12.36.77 12.39-7.06-5.49-17.39-12.31-21.33"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "registry-hero_svg__cls-2",
    d: "M404.93 71.88a1.21 1.21 0 00-1.85.35l-13.26 24.86a3.6 3.6 0 003.53 5.26l26.24-2.69a1.21 1.21 0 001-1.61L414 79.6z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "registry-hero_svg__cls-2",
    cx: 435.64,
    cy: 239.93,
    rx: 13.28,
    ry: 3.8
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      isolation: "isolate"
    },
    fill: "url(#registry-hero_svg__linear-gradient-2)",
    opacity: 0.21,
    d: "M96.55 244.59l-18.5-4.94 21.12-15.12 6.06 10.47-8.68 9.59"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      isolation: "isolate"
    },
    fill: "url(#registry-hero_svg__linear-gradient-3)",
    opacity: 0.21,
    d: "M210.39 179.2l-4.13-2.62-5.38 1.74-9.75 1.75.53-6.11 15.67-9.59h4.35l-1.29 14.83"
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "registry-hero_svg__cls-9",
    d: "M76.35 272.89l-11.51-4.76s-3.75-7-1.4-13.95 18.48-21.8 18.48-21.8l6.52 5.24 4.9 2.94z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "registry-hero_svg__cls-10",
    cx: 83.91,
    cy: 256.41,
    rx: 18.45,
    ry: 10.44,
    transform: "rotate(-58 83.775 255.64)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "registry-hero_svg__cls-2",
    cx: 83.91,
    cy: 256.41,
    rx: 7.56,
    ry: 4.27,
    transform: "rotate(-57.93 83.9 256.4)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "registry-hero_svg__cls-2",
    d: "M77.88 268.47a1.28 1.28 0 001.11-.63l13.79-23.47a1.27 1.27 0 00-.45-1.75 1.29 1.29 0 00-1.76.45l-13.79 23.47a1.27 1.27 0 001.1 1.93z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "registry-hero_svg__cls-2",
    d: "M90.28 261a1.28 1.28 0 00.6-2.42L77.3 251.5a1.28 1.28 0 10-1.19 2.27l13.58 7.1a1.26 1.26 0 00.59.13z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "registry-hero_svg__cls-9",
    d: "M188.94 210.76L177.43 206s-3.75-7-1.4-13.95 18.47-21.8 18.47-21.8l6.5 5.25 4.91 2.94z"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "registry-hero_svg__cls-10",
    cx: 196.49,
    cy: 194.29,
    rx: 18.45,
    ry: 10.44,
    transform: "rotate(-57.93 196.484 194.288)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    className: "registry-hero_svg__cls-2",
    cx: 196.49,
    cy: 194.29,
    rx: 7.56,
    ry: 4.27,
    transform: "rotate(-57.93 196.484 194.288)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "registry-hero_svg__cls-2",
    d: "M190.47 206.35a1.27 1.27 0 001.1-.63l13.8-23.48a1.28 1.28 0 00-2.21-1.3l-13.8 23.48a1.28 1.28 0 00.46 1.75 1.25 1.25 0 00.65.18z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "registry-hero_svg__cls-2",
    d: "M202.87 198.89a1.28 1.28 0 00.59-2.41l-13.57-7.11a1.28 1.28 0 10-1.19 2.27l13.57 7.11a1.29 1.29 0 00.6.14zM115.19 131.24l52.7-24.41 57.99 34.87-162.16 99.4H48.9L7.52 215.82l-2.58-10.47L80.6 147.8l34.59-16.56z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "registry-hero_svg__cls-2",
    d: "M63.72 241.1l-.66 17.44 8.44-16.57 16.6-10.46 4.52-1.74 6.85 11.33 71.52-40.1 12.44-22.68 21.21-13.08 5.41 7.85 10.99-6.1 4.84-25.29-162.16 99.4zM4.94 205.35l-.27 13.08.75 11.34 44.8 26.16 13 .87 1.38-15.7H48.9L7.52 215.82l-2.58-10.47z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "registry-hero_svg__cls-9",
    d: "M5.55 218.43l-1.03 1.75-1.07 12.2 47.18 28.77h13.95l1.26-4.35 8.27-14.83 19.09-11.23 5.47 9.05-2.12 4.8 73.41-41.85h2.62l14.27-23.54 19.41-11.59 3.71 6.35.42 5.24 12.17-9.59.31-3.5-1.37-1.5-11.38 7.61-5.34-8.72-22.07 13.08-10.46 20.05-2.06 3.49-70.64 40.11-7.58-13.08-20.25 12.21-8.35 15.69H50.29L6.37 228.9l-.82-10.47z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      isolation: "isolate"
    },
    fill: "url(#registry-hero_svg__linear-gradient-4)",
    opacity: 0.3,
    d: "M26.3 191.4l54.72 31.39 45.89-44.96-46.31-28-54.3 41.57z"
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "registry-hero_svg__cls-12",
    d: "M80.6 149.83l35.46-16.11 51.31 30.53-40.46 13.58-46.31-28zM121.29 131.24l46.31 28.77 51.38-19.18-51.4-30.52-45.42 20.93"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "registry-hero_svg__cls-13",
    d: "M5.51 208.84l2.73 8.72 18.9 13.08L48.9 241.1l14.75.87-.15 1.75-14.75-.88-22.63-10.46-18.83-13.95-1.93-7.84.15-1.75z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "registry-hero_svg__cls-12",
    d: "M83.48 224.53l44.08-45.33 40.45-13.96.34 6.11-84.87 53.18z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "registry-hero_svg__cls-2",
    d: "M127.24 179.21l4.87 14.85 4.01-2.51-5.18-13.48-3.7 1.14z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      isolation: "isolate"
    },
    fill: "url(#registry-hero_svg__linear-gradient-5)",
    opacity: 0.21,
    d: "M50.29 255.05l-1.54-12.21 14.75.88h5.9l-6.03 11.33H50.29z"
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    className: "registry-hero_svg__cls-4",
    d: "M278.49 299.02L117.54 392.3l115.19 66.82 160.95-93.29-115.19-66.81zM393.7 365.88l-160.95 93.28 115.19 66.82 160.95-93.28-115.19-66.82z"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "registry-hero_svg__cls-9",
    d: "M117.04 315.58h10.86v12.56h-10.86z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "registry-hero_svg__Path",
    className: "registry-hero_svg__cls-9",
    d: "M232.23 395.04l160.95-93.28-115.19-66.81-160.95 93.28 115.19 66.81z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "registry-hero_svg__cls-9",
    d: "M495.86 356.14h12.53v12.44h-12.53zM232.25 382.51h12.53v12.53h-12.53z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "registry-hero_svg__Path-2",
    "data-name": "Path",
    className: "registry-hero_svg__cls-9",
    d: "M347.44 461.9l160.95-93.28-115.19-66.81-160.95 93.28 115.19 66.81z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "registry-hero_svg__Path-3",
    "data-name": "Path",
    className: "registry-hero_svg__cls-2",
    d: "M347.19 449.46l161.2-93.34-115.45-66.75-160.69 93.16 114.94 66.93z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "registry-hero_svg__cls-12",
    d: "M396.44 287.05s18.9-9.22 53.2 13.42c29.85 19.71 68 43 68 43l-170.28 96.19s-34.14-17.27-60.11-32.36c-23.45-13.63-54.08-25.37-54.08-25.37z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "registry-hero_svg__cls-4",
    d: "M347.36 440a.47.47 0 01-.16 0c-.35-.18-34.46-17.45-60.14-32.37-23.15-13.46-53.72-25.23-54-25.35a.36.36 0 01-.24-.32.38.38 0 01.18-.35l163.27-94.88c.19-.09 19.48-9 53.57 13.45 29.5 19.48 67.58 42.73 68 43a.39.39 0 01.18.33.42.42 0 01-.19.32L347.55 440a.41.41 0 01-.19 0zM234 381.86c4.79 1.88 32.19 12.79 53.4 25.12 24.69 14.35 57.2 30.88 59.91 32.26l169.52-95.81c-4.73-2.92-39.83-24.43-67.4-42.64-33.36-22-52.27-13.66-52.81-13.41z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "registry-hero_svg__cls-12",
    d: "M395.52 287.63S415 276.38 449.25 299c29.85 19.71 63.51 29.68 63.51 29.68L339.37 428s-27.85-10.25-53-26.29c-22.86-14.6-54.13-19.2-54.13-19.2z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "registry-hero_svg__cls-4",
    d: "M339.37 428.37a.27.27 0 01-.13 0c-.28-.1-28.18-10.44-53.06-26.33-22.53-14.38-53.67-19.09-54-19.14a.37.37 0 01-.13-.69l163.27-94.88c.2-.12 20-11.11 54.13 11.4 29.46 19.45 63.07 29.54 63.4 29.63a.39.39 0 01.27.32.37.37 0 01-.19.37l-173.38 99.27a.29.29 0 01-.18.05zm-106-46.06c5.63.95 32.91 6.1 53.24 19.08 23.83 15.21 50.42 25.32 52.75 26.2l172.49-98.78c-5.37-1.69-35.81-11.67-62.78-29.48-17.6-11.62-31.17-14.09-39.46-14.12h-.14c-8.87 0-13.69 2.72-13.73 2.75z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M395.52 287.63S416.75 270.31 451 293c29.85 19.7 55.53 17.41 55.53 17.41L335.09 414.25s-19.77-6.77-44.91-22.81c-22.86-14.6-57.93-8.93-57.93-8.93z",
    style: {
      isolation: "isolate"
    },
    fill: "url(#registry-hero_svg__linear-gradient-6)",
    opacity: 0.3
  }), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "registry-hero_svg__Path-4",
    "data-name": "Path",
    className: "registry-hero_svg__cls-2",
    d: "M231.97 382.51l161.21-93.35-115.45-66.74-160.69 93.16 114.93 66.93z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "registry-hero_svg__cls-12",
    d: "M232 382.56s-60.41-51.64-107.54-66.07c1.3-.75 157-100.17 157-100.17s11.32 16.24 111.79 72.9c-.31.2-161.25 93.34-161.25 93.34z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "registry-hero_svg__cls-4",
    d: "M232 382.94a.38.38 0 01-.25-.09c-.6-.52-60.89-51.76-107.4-66a.38.38 0 01-.26-.31.37.37 0 01.19-.37c1.25-.74 155.35-99.17 156.91-100.17a.37.37 0 01.5.1c.12.17 12.62 16.93 111.68 72.79a.42.42 0 01.19.29.39.39 0 01-.13.32c-.24.21-112.86 65.38-161.27 93.39a.41.41 0 01-.16.05zm-106.67-66.56c45.19 14.18 102.8 62.44 106.69 65.73 6.69-3.88 150.39-87 160.41-92.89-93-52.49-109.16-70-111.13-72.4-9.3 5.93-144.94 92.58-155.97 99.56z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "registry-hero_svg__cls-12",
    d: "M232 382.51s-20.16-34.74-88.39-66.93c1.29-.75 162.88-99.6 162.88-99.6s6.75 24.22 86.71 73.18c-.26.21-161.2 93.35-161.2 93.35z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "registry-hero_svg__cls-4",
    d: "M232 382.89a.39.39 0 01-.33-.19c-.2-.35-20.91-35-88.22-66.78a.35.35 0 01-.21-.32.36.36 0 01.18-.34c1.28-.74 161.25-98.61 162.87-99.6a.39.39 0 01.33 0 .43.43 0 01.23.25c.07.24 7.74 24.72 86.55 73a.4.4 0 01.18.29.39.39 0 01-.13.32c-.24.2-112.86 65.38-161.27 93.39a.41.41 0 01-.18-.02zm-87.6-67.35c63.6 30.16 85.46 62.89 87.7 66.46 7.76-4.48 150.57-87.12 160.36-92.84-73.69-45.2-84.85-69-86.2-72.61-10.51 6.45-151.44 92.64-161.88 98.99z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M232 381.91s-16.85-39.91-64.68-68.78l165.81-96.81s-.78 15.1 60.05 72.24c-.24.21-161.18 93.35-161.18 93.35z",
    style: {
      isolation: "isolate"
    },
    fill: "url(#registry-hero_svg__linear-gradient-7)",
    opacity: 0.3
  }), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "registry-hero_svg___-_-Ockam_io",
    "data-name": "- -Ockam.io"
  }, /*#__PURE__*/React.createElement("g", {
    id: "registry-hero_svg__img-hero"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "registry-hero_svg__Oval",
    className: "registry-hero_svg__cls-13",
    cx: 343.1,
    cy: 333.49,
    rx: 1.62,
    ry: 1.02,
    transform: "rotate(-2.92 343.66 333.837)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "registry-hero_svg__Oval-2",
    className: "registry-hero_svg__cls-13",
    cx: 360.87,
    cy: 336.33,
    rx: 1.62,
    ry: 1.02,
    transform: "rotate(-2.92 361.447 336.843)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "registry-hero_svg__Oval-3",
    className: "registry-hero_svg__cls-13",
    cx: 387.2,
    cy: 361.71,
    rx: 1.62,
    ry: 1.02,
    transform: "rotate(-2.92 387.693 362.246)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "registry-hero_svg__Oval-4",
    className: "registry-hero_svg__cls-13",
    cx: 374.39,
    cy: 327.89,
    rx: 1.62,
    ry: 1.02,
    transform: "rotate(-2.92 375.012 328.355)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "registry-hero_svg__Oval-5",
    className: "registry-hero_svg__cls-13",
    cx: 355.89,
    cy: 367.32,
    rx: 1.62,
    ry: 1.02,
    transform: "rotate(-2.92 356.34 367.728)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "registry-hero_svg__Oval-6",
    className: "registry-hero_svg__cls-13",
    cx: 333.84,
    cy: 353.21,
    rx: 1.62,
    ry: 1.02,
    transform: "rotate(-2.92 334.322 353.622)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "registry-hero_svg__Oval-7",
    className: "registry-hero_svg__cls-13",
    cx: 369.42,
    cy: 358.88,
    rx: 1.62,
    ry: 1.02,
    transform: "rotate(-2.92 369.9 359.437)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "registry-hero_svg__Oval-8",
    className: "registry-hero_svg__cls-13",
    cx: 378.64,
    cy: 339.16,
    rx: 1.62,
    ry: 1.02,
    transform: "rotate(-2.92 379.239 339.652)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "registry-hero_svg__Oval-9",
    className: "registry-hero_svg__cls-13",
    cx: 351.65,
    cy: 356.04,
    rx: 1.62,
    ry: 1.02,
    transform: "rotate(-2.92 352.114 356.431)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "registry-hero_svg__Oval-10",
    className: "registry-hero_svg__cls-13",
    cx: 382.92,
    cy: 350.43,
    rx: 1.62,
    ry: 1.02,
    transform: "rotate(-2.92 383.466 350.949)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "registry-hero_svg__Oval-11",
    className: "registry-hero_svg__cls-13",
    cx: 347.36,
    cy: 344.78,
    rx: 1.62,
    ry: 1.02,
    transform: "rotate(-2.92 347.882 345.33)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "registry-hero_svg__Oval-12",
    className: "registry-hero_svg__cls-13",
    cx: 396.45,
    cy: 341.98,
    rx: 1.62,
    ry: 1.02,
    transform: "rotate(-2.92 397.03 342.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "registry-hero_svg__Path-5",
    "data-name": "Path",
    className: "registry-hero_svg__cls-4",
    d: "M340.75 334.89c-8.78 2.54-13 9-9.41 14.45a9.67 9.67 0 001.72 2 4 4 0 00-1.41.53 2.06 2.06 0 00-.64.57c-6.24-5.49-4-13.35 5-17.54a26.11 26.11 0 013.93-1.46 1.63 1.63 0 00.81 1.45z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "registry-hero_svg__Path-2-2",
    "data-name": "Path-2",
    className: "registry-hero_svg__cls-4",
    d: "M345 346.17a16.9 16.9 0 00-8.93 5.56 4.11 4.11 0 00-2.4-.51c2.12-2.91 5.88-5.26 10.54-6.56a1.43 1.43 0 00.79 1.51z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "registry-hero_svg__Path-3-2",
    "data-name": "Path-3",
    className: "registry-hero_svg__cls-4",
    d: "M344.06 339.32a8.85 8.85 0 002.55 3.53 4 4 0 00-1.41.53 2.24 2.24 0 00-.61.54c-2.89-2.49-4.09-5.64-3.35-8.77a3.62 3.62 0 001 .27 4.36 4.36 0 001.57 0 6.64 6.64 0 00.29 3.92z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "registry-hero_svg__Path-4-2",
    "data-name": "Path-4",
    className: "registry-hero_svg__cls-4",
    d: "M348.61 355.56a1.35 1.35 0 00.37 1.63 27.79 27.79 0 01-13.89-2.2 4.42 4.42 0 00.92-.4 2.15 2.15 0 00.82-.87 23.76 23.76 0 0011.79 1.84z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "registry-hero_svg__Path-5-2",
    "data-name": "Path-5",
    className: "registry-hero_svg__cls-4",
    d: "M350.82 354.13a3.28 3.28 0 00-2 1.08c-2.86-2.5-4-5.63-3.34-8.77a4.65 4.65 0 002.53.26 7.83 7.83 0 002.81 7.43z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "registry-hero_svg__Path-6",
    className: "registry-hero_svg__cls-4",
    d: "M334.36 356.22c-.31 6 7.18 10.81 16.69 10.71.61 0 1.21 0 1.81-.09a1.29 1.29 0 00-.05 1 1.82 1.82 0 00.43.62c-.75.05-1.49.1-2.22.11-10.95.12-19.57-5.39-19.25-12.32a8.25 8.25 0 01.18-1.4 4.9 4.9 0 002.54.26 6.86 6.86 0 00-.13 1.11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "registry-hero_svg__Path-7",
    className: "registry-hero_svg__cls-4",
    d: "M350.06 362.33a7.86 7.86 0 01-.31-4.65 4.61 4.61 0 002.54.27c-.58 2.65.4 5.3 2.78 7.43a3.42 3.42 0 00-2 1.09 10.94 10.94 0 01-3-4.14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "registry-hero_svg__Path-8",
    className: "registry-hero_svg__cls-4",
    d: "M368.5 360.8a4.71 4.71 0 001.06 0c-2.09 2.93-5.88 5.28-10.52 6.58a1.46 1.46 0 00-.77-1.53 16.84 16.84 0 008.92-5.59 3 3 0 001.31.54z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "registry-hero_svg__Path-9",
    className: "registry-hero_svg__cls-4",
    d: "M366.37 358.41a1.37 1.37 0 00.41 1.61 27.87 27.87 0 01-13.88-2.21 2.85 2.85 0 001.72-1.26 24.31 24.31 0 0011.75 1.86z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "registry-hero_svg__Path-10",
    className: "registry-hero_svg__cls-4",
    d: "M384.14 361.26a1.39 1.39 0 00.41 1.61 27.76 27.76 0 01-13.88-2.21 2.81 2.81 0 001.76-1.26 24.22 24.22 0 0011.71 1.86z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "registry-hero_svg__Path-11",
    className: "registry-hero_svg__cls-4",
    d: "M359 369.84c-.64-.23-1.24-.48-1.81-.75a2.77 2.77 0 001.73-1.26c.47.21.95.42 1.44.59 8.11 2.93 18.76 1 23.79-4.25a11.28 11.28 0 00.83-1 4 4 0 002.42.52 13.06 13.06 0 01-1.07 1.27c-5.77 6-18 8.25-27.33 4.88z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "registry-hero_svg__Path-12",
    className: "registry-hero_svg__cls-4",
    d: "M383.07 352.39c-2.13 2.93-5.89 5.28-10.53 6.6a1.54 1.54 0 00-.78-1.53 17 17 0 008.91-5.58 4.17 4.17 0 002.4.51z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "registry-hero_svg__Path-13",
    className: "registry-hero_svg__cls-4",
    d: "M386.21 355.86a9 9 0 00-2.56-3.53 3.93 3.93 0 001.41-.52 2.68 2.68 0 00.62-.54c2.88 2.48 4.09 5.62 3.34 8.77a4.27 4.27 0 00-2.52-.26 6.73 6.73 0 00-.29-3.92z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "registry-hero_svg__Path-14",
    className: "registry-hero_svg__cls-4",
    d: "M390.5 346.72a13.63 13.63 0 003.7-3.28 4.27 4.27 0 002.4.52c-2.13 2.92-5.92 5.27-10.56 6.55a1.52 1.52 0 00-.79-1.51 20.74 20.74 0 005.25-2.28z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "registry-hero_svg__Path-15",
    className: "registry-hero_svg__cls-4",
    d: "M389.51 360.29c8.79-2.54 13-9 9.41-14.44a9.71 9.71 0 00-1.71-2 4.29 4.29 0 001.41-.52 2.37 2.37 0 00.62-.56c6.24 5.48 4 13.33-5 17.54a26.07 26.07 0 01-3.93 1.45 1.51 1.51 0 00-.8-1.47z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "registry-hero_svg__Path-16",
    className: "registry-hero_svg__cls-4",
    d: "M381.66 339.6a1.25 1.25 0 00.06-1 1.69 1.69 0 00-.41-.6 27.9 27.9 0 0113.89 2.19 4.89 4.89 0 00-.91.39 2.09 2.09 0 00-.82.87 24.08 24.08 0 00-11.81-1.85z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "registry-hero_svg__Path-17",
    className: "registry-hero_svg__cls-4",
    d: "M379.43 341.05a3.34 3.34 0 002-1.08c2.85 2.5 4.06 5.64 3.36 8.79a4.51 4.51 0 00-2.54-.26c.54-2.67-.47-5.31-2.82-7.45z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "registry-hero_svg__Path-18",
    className: "registry-hero_svg__cls-4",
    d: "M373.12 326.08a2.79 2.79 0 00-1.73 1.26c-.47-.22-.94-.42-1.44-.61-8.11-2.92-18.76-1-23.77 4.26-.29.32-.57.65-.83 1a4 4 0 00-2.41-.52 12.72 12.72 0 011.06-1.25c5.75-6.06 18-8.25 27.33-4.9.61.25 1.2.48 1.79.76z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "registry-hero_svg__Path-19",
    className: "registry-hero_svg__cls-4",
    d: "M380.2 332.85a7.86 7.86 0 01.31 4.65 4.66 4.66 0 00-2.53-.29c.58-2.66-.42-5.31-2.78-7.44a3.39 3.39 0 002-1.07 10.44 10.44 0 013 4.15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "registry-hero_svg__Path-20",
    className: "registry-hero_svg__cls-4",
    d: "M395.92 338.94c.27-6-7.2-10.82-16.73-10.72-.59 0-1.19 0-1.77.09a1.27 1.27 0 00.06-1 1.73 1.73 0 00-.44-.6c.72-.06 1.49-.1 2.22-.11 10.95-.12 19.55 5.37 19.24 12.3a9.74 9.74 0 01-.19 1.41 4.61 4.61 0 00-2.52-.26 8.06 8.06 0 00.13-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "registry-hero_svg__Path-21",
    className: "registry-hero_svg__cls-4",
    d: "M357.85 335.8a24 24 0 00-11.7-1.88 1.44 1.44 0 00-.39-1.61 27.69 27.69 0 0113.85 2.23 2.75 2.75 0 00-1.76 1.26z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "registry-hero_svg__Path-22",
    className: "registry-hero_svg__cls-4",
    d: "M361.76 334.38a5.07 5.07 0 00-1 0c2.12-2.93 5.88-5.28 10.52-6.58a1.23 1.23 0 000 .66 1.89 1.89 0 00.73.85 16.82 16.82 0 00-8.93 5.6 3.31 3.31 0 00-1.32-.53z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "registry-hero_svg__Path-23",
    className: "registry-hero_svg__cls-4",
    d: "M347.17 342.78c2.14-2.9 5.92-5.25 10.54-6.57a1.51 1.51 0 00.81 1.51 17.1 17.1 0 00-8.91 5.58 4.31 4.31 0 00-2.44-.52z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "registry-hero_svg__Path-24",
    className: "registry-hero_svg__cls-4",
    d: "M363.9 336.74a1.36 1.36 0 00-.42-1.59 28 28 0 0113.89 2.2 2.75 2.75 0 00-1.73 1.26 24.52 24.52 0 00-11.74-1.86z"
  })))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "registry-hero_svg__cls-13",
    d: "M313.22 309.9c-8.38-20.71-41.82-42.49-42.15-42.71l1.95-1.67c1.44.93 33.47 20.85 42.61 43.44z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "registry-hero_svg__cls-12",
    d: "M266.86 341.9c-8.37-20.71-42.93-45-43.26-45.2l4.59-2.9c1.45.93 34.93 22.55 44.07 45.14z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "registry-hero_svg__cls-4",
    d: "M158.61 471.37a.38.38 0 01-.33-.18.38.38 0 01.13-.51l97.1-58.16a.37.37 0 11.39.64l-97.1 58.16a.45.45 0 01-.19.05z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "registry-hero_svg__cls-4",
    d: "M152.78 478.47c-4.55 0-8.12-2-8.12-4.51s3.57-4.52 8.12-4.52 8.11 2 8.11 4.52-3.56 4.51-8.11 4.51zm0-8.28c-4 0-7.37 1.72-7.37 3.77s3.38 3.76 7.37 3.76 7.36-1.72 7.36-3.76-3.37-3.77-7.36-3.77zM91.27 441.33c-4.55 0-8.11-2-8.11-4.51s3.56-4.52 8.11-4.52 8.11 2 8.11 4.52-3.56 4.51-8.11 4.51zm0-8.28c-4 0-7.36 1.72-7.36 3.77s3.37 3.76 7.36 3.76 7.36-1.72 7.36-3.76-3.37-3.77-7.36-3.77zM490.11 463.17a.41.41 0 01-.19-.05l-67.8-39.35a.39.39 0 01-.14-.52.36.36 0 01.51-.13l67.81 39.35a.36.36 0 01.13.51.37.37 0 01-.32.19z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "registry-hero_svg__cls-4",
    d: "M494.11 470.85c-4.55 0-8.11-2-8.11-4.51s3.56-4.52 8.11-4.52 8.11 2 8.11 4.52-3.56 4.51-8.11 4.51zm0-8.28c-4 0-7.36 1.72-7.36 3.77s3.37 3.76 7.36 3.76 7.36-1.72 7.36-3.76-3.37-3.77-7.36-3.77zM523.39 399.63c-4.55 0-8.11-2-8.11-4.52s3.56-4.52 8.11-4.52 8.11 2 8.11 4.52-3.56 4.52-8.11 4.52zm0-8.29c-4 0-7.36 1.73-7.36 3.77s3.37 3.77 7.36 3.77 7.36-1.73 7.36-3.77-3.37-3.77-7.36-3.77zM96.09 434a.38.38 0 01-.33-.18.39.39 0 01.14-.52l23-13.1a.35.35 0 01.37 0l23.15 13 73.44-44.78a.37.37 0 11.39.64L142.62 434a.39.39 0 01-.38 0l-23.16-13-22.8 13a.43.43 0 01-.19 0z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "registry-hero_svg__cls-4",
    d: "M495.52 412.21a.32.32 0 01-.19 0l-26.59-15.39a.37.37 0 01.37-.65l26.41 15.28 22.76-13.24a.37.37 0 11.37.65l-22.94 13.35a.34.34 0 01-.19 0z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "registry-hero_svg__cls-12",
    d: "M385.25 281.49l29.29-17.01"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "registry-hero_svg__cls-4",
    d: "M385.25 281.86a.39.39 0 01-.33-.19.37.37 0 01.14-.51l29.29-17a.39.39 0 01.52.14.37.37 0 01-.14.51l-29.29 17a.45.45 0 01-.19.05z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "registry-hero_svg__cls-4",
    d: "M419.61 265.81c-4.55 0-8.11-2-8.11-4.52s3.56-4.51 8.11-4.51 8.11 2 8.11 4.51-3.56 4.52-8.11 4.52zm0-8.28c-4 0-7.36 1.72-7.36 3.76s3.37 3.77 7.36 3.77 7.36-1.72 7.36-3.77-3.37-3.76-7.36-3.76zM213.1 261a.37.37 0 01-.18 0l-41.47-23.77a.36.36 0 01-.19-.32.37.37 0 01.19-.33l23.08-13.46a.37.37 0 01.51.13.37.37 0 01-.13.51l-22.52 13.14 40.9 23.45a.37.37 0 01.14.51.39.39 0 01-.33.14z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "registry-hero_svg__cls-4",
    d: "M200.26 225c-4.55 0-8.11-2-8.11-4.52s3.56-4.52 8.11-4.52 8.11 2 8.11 4.52-3.56 4.52-8.11 4.52zm0-8.29c-4 0-7.36 1.73-7.36 3.77s3.37 3.77 7.36 3.77 7.36-1.73 7.36-3.77-3.37-3.82-7.36-3.82z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "registry-hero_svg__cls-12",
    d: "M182.4 276.6l-44.65-25.92"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "registry-hero_svg__cls-4",
    d: "M182.4 277a.41.41 0 01-.19-.05L137.56 251a.38.38 0 01.38-.65l44.65 25.92a.36.36 0 01.13.51.37.37 0 01-.32.22z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "registry-hero_svg__cls-4",
    d: "M132.68 252c-4.55 0-8.11-2-8.11-4.52s3.56-4.52 8.11-4.52 8.12 2 8.12 4.52-3.57 4.52-8.12 4.52zm0-8.29c-4 0-7.36 1.73-7.36 3.77s3.37 3.77 7.36 3.77 7.37-1.73 7.37-3.77-3.38-3.75-7.37-3.75z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "registry-hero_svg__cls-1",
    d: "M-.27-.63h540v540h-540z"
  })));
}

export default __webpack_public_path__ + "static/registry-hero.1ac4232b.svg";
export { SvgRegistryHero as ReactComponent };